/**
 * `?mute=1` silences every sound on the page (game, explorer and scenario viewer) for the rest of this tab's visit, reloads
 * included; `?mute=0` turns it back off. Import it first in an entry point, before anything creates audio. It never touches the
 * player's saved mix: media elements and audio contexts keep running (timings, ends and cross-fades are unchanged), only their
 * output is silent.
 */
const KEY = 'nimblez.mute';

function requested(): boolean {
  const value = new URLSearchParams(location.search).get('mute');
  try {
    if (value !== null) value === '0' ? sessionStorage.removeItem(KEY) : sessionStorage.setItem(KEY, '1');
    return sessionStorage.getItem(KEY) === '1';
  } catch { return value !== null && value !== '0'; }
}

export const audioMuted = requested();

if (audioMuted) {
  const play = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function (this: HTMLMediaElement) { this.muted = true; return play.call(this); };
  if (typeof AudioContext !== 'undefined') {
    // Every graph ends at `destination`, so a silent gain in front of the real one mutes the whole context.
    class MutedAudioContext extends AudioContext {
      #silence: GainNode | undefined;
      override get destination(): AudioDestinationNode {
        if (!this.#silence) { this.#silence = this.createGain(); this.#silence.gain.value = 0; this.#silence.connect(super.destination); }
        return this.#silence as unknown as AudioDestinationNode;
      }
    }
    globalThis.AudioContext = MutedAudioContext;
  }
}
